import React, { useState, useEffect, useRef } from "react";
import "./SecurityOneQuickMenus.scss";
import VisitorFaceScan from "../../../../faceRecognition/VisitorFaceScan";
import { useNavigate } from "react-router-dom";

// FACE MODALS
// import * as faceapi from "face-api.js";
import { loadModels } from "../../../../faceRecognition/modelLoader";
// import { recognizeFace } from "../../../../faceRecognition/models/faceRecognition.module";

// FIREBASE
// import { useFirestore } from "../../../../firebase-files/hooks/useFirestore";
import { useAuthContext } from "../../../../firebase-files/hooks/useAuthContext";
import PGLoaders from "../../../../default-pages/PGLoaders/PGLoaders";
// import { timestamp } from "../../../../firebase-config/config";
// import { projectStorage } from "../../../../firebase-config/config";

const SecurityOneScanFace = ({ showPopup, setShowPopup }) => {
  const { user } = useAuthContext();

  const faceScanRef = useRef();
  const navigate = useNavigate();

  // FACE SCAN STATUS
  const [statusText, setStatusText] = useState("");
  const [isFaceMatched, setIsFaceMatched] = useState(false);
  const [isScanningNow, setIsScanningNow] = useState(false);
  const [isCamOpenStatus, setIsCamOpenStatus] = useState(false); // 👈 Add this state

  const [status, setStatus] = useState("");
  // const [previewUrl, setPreviewUrl] = useState(null);
  // const [showPopup, setShowPopup] = useState(false);
  const [faceScanned, setFaceScanned] = useState(false);
  const [faceRegistring, setFaceRegistring] = useState(false);
  const [faceRegistered, setFaceRegistered] = useState(false);
  const [isScanning, setIsScanning] = useState(false); // 👈 Add this state

  const videoRef = React.useRef(null);
  // const [descriptor, setDescriptor] = useState(null);

  useEffect(() => {
    const retryInterval = setInterval(() => {
      if (!videoRef.current?.srcObject) {
        navigator.mediaDevices
          .getUserMedia({ video: true })
          .then((stream) => {
            if (videoRef.current) {
              videoRef.current.srcObject = stream;
              setIsCamOpenStatus(true);
            }
          })
          .catch(() => {
            // Don't log too often
          });
      }
    }, 3000);

    return () => clearInterval(retryInterval);
  }, []);

  useEffect(() => {
    const start = async () => {
      await loadModels(); // models load
    };
    start();
  }, []);

  const handlePopup = () => {
    setShowPopup(false);
    setFaceScanned(false);
    setIsScanning(false);
    setStatus("");
    setIsCamOpenStatus(false);
    setFaceRegistered(false);
  };
  return (
    <div>
      {/* START CODE FACE REGISTER POPUP */}
      {showPopup && (
        <div className="face-register-overlay">
          <div className="face-register-container">
            <div className="face-register-card">
              <div className="face-register-header">
                <span>
                  {new Date().toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </span>
                <span onClick={handlePopup}>
                  {!faceRegistring && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="20px"
                      viewBox="0 -960 960 960"
                      width="20px"
                      fill="currentColor"
                      style={{ cursor: "pointer" }}
                    >
                      <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                    </svg>
                  )}
                </span>
              </div>
              <div className="face-register-title">Scan Face</div>
              <div className="face-register-content">
                <>
                  <div className="d-flex justify-content-center align-items-center flex-column">
                    {/* 👇 show face scan status here in parent */}
                    {statusText && (
                      <p
                        style={{
                          marginTop: "10px",
                          fontWeight: "bold",
                          color: statusText.includes("Hello") ? "green" : "red",
                        }}
                      >
                        {statusText}
                      </p>
                    )}
                  </div>
                  <div className="face-register-avatar mt-2">
                    <div className={isScanning ? "video-scan-border" : ""}>
                      <VisitorFaceScan
                        ref={faceScanRef}
                        size="100%"
                        width="150px"
                        height="150px"
                        borderRadius="50%"
                        showStatus={true}
                        setParentStatus={setStatusText}
                        handleCamOpenStatus={() => {
                          setIsCamOpenStatus(true);
                        }}
                        onMatch={(user) => {
                          setIsFaceMatched(true);
                          setIsScanningNow(false);

                          if (user && user.phoneNumber) {
                            navigate(`/visitor-log/${user.phoneNumber}`);
                          } else {
                            navigate(`/visitor-log/new`);
                          }
                        }}
                        onNoMatch={() => {
                          console.log("❌ No match found");
                          setIsFaceMatched(false);
                          setIsScanningNow(false);
                          const allowedRoles = [
                            "admin",
                            "superAdmin",
                            "frontDesk",
                          ];

                          // CAPTURE FRAME FROM VIDEO
                          const video = document.querySelector("video"); // assumes FaceScan renders a <video>
                          if (video) {
                            const canvas = document.createElement("canvas");
                            canvas.width = video.videoWidth;
                            canvas.height = video.videoHeight;
                            const ctx = canvas.getContext("2d");
                            ctx.drawImage(
                              video,
                              0,
                              0,
                              canvas.width,
                              canvas.height
                            );
                            const imageDataUrl = canvas.toDataURL("image/jpeg");

                            // STORE TO LOCAL STORAGE
                            localStorage.setItem("unmatchedFace", imageDataUrl);
                          }

                          // NAVIGATE TO FORM
                          if (allowedRoles.includes(user?.role)) {
                            navigate("/visitor-log/new");
                          }

                          if (allowedRoles.includes(user?.role)) {
                            navigate("/visitor-log/new");
                          }
                        }}
                        onError={(e) => {
                          console.log("⚠️ Face scan error", e);
                          setIsScanningNow(false);
                        }}
                      />
                    </div>
                    {user && user.role === "customer" && (
                      <p style={{ color: "red", fontWeight: "700" }}>
                        You are not authorized!
                      </p>
                    )}
                  </div>
                  <div className="face-register-details">
                    {/* <div className="face-register-detail-left">
                      <p>
                        <strong>Last Registration</strong>
                      </p>
                      <p>
                        {user?.faceRegistration &&
                        user.faceRegistration.length > 0
                          ? new Date(
                              Math.max(
                                ...user.faceRegistration.map((entry) =>
                                  entry.createdAt?.toDate
                                    ? entry.createdAt.toDate().getTime()
                                    : 0
                                )
                              )
                            ).toLocaleString("en-IN", {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            })
                          : "No registrations yet"}
                      </p>
                    </div> */}
                    {/* <div className="face-register-detail-right">
                      <p>
                        <strong>Current Date</strong>
                      </p>
                      <p>23 Apr 2025</p>
                    </div> */}
                  </div>

                  <div className="d-flex justify-content-between">
                    <button
                      className="btn_border"
                      onClick={handlePopup}
                      disabled={faceRegistring}
                    >
                      Cancel
                    </button>

                    {!isCamOpenStatus ? (
                      <div className="d-flex align-items-center">
                        <PGLoaders />
                      </div>
                    ) : user && user.role !== "customer" ? (
                      !isScanningNow ? (
                        <button
                          onClick={() => {
                            setIsScanningNow(true);
                            faceScanRef.current?.triggerScan();
                          }}
                          className="btn_fill"
                          style={{ cursor: "pointer", opacity: 1 }}
                        >
                          {isScanning ? "Scanning..." : "Scan"}
                        </button>
                      ) : (
                        <button
                          className="btn_fill"
                          onClick={() => {
                            setIsScanningNow(true);
                            faceScanRef.current?.triggerScan();
                          }}
                        >
                          {isScanning ? "Scanning..." : "Scan"}
                        </button>
                      )
                    ) : null}
                  </div>
                </>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* END CODE FACE REGISTER POPUP */}
    </div>
  );
};

export default SecurityOneScanFace;
